// extracted by mini-css-extract-plugin
export default {"menu":"Spreadsheet_menu__7IBrb","item":"Spreadsheet_item__9SGML","checkboxGroup":"Spreadsheet_checkboxGroup__vCJJY"};